import {jwtServerInstance} from "../index";
import { wsInstance } from "../index";
import {getTokenUser} from "@/lib/utils";
import qs from	'qs'

//新增一条菜单数据记录
export const addPlateformAccount = (plateform) => {
    return jwtServerInstance.request({
        url:'/b2cplateform/add',
        method:'post',
        data:plateform
    })
}

export const getPlateformAccounts=() =>{
    return jwtServerInstance.request({
        url:'/b2cplateform/query',
        method:'post'
    })
}

export const getPlateformAccountInfo=() =>{
    return jwtServerInstance.request({
        url:'/b2cplateform/queryplateinfo',
        method:'post'
    })
}

export const getOrderPlateforms=() =>{
    return jwtServerInstance.request({
        url:'/b2cplateform/queryorderplate',
        method:'post'
    })
}

export const getPlateformAccount=(plateformId) =>{
    return jwtServerInstance.request({
        url:'/b2cplateform/detail',
        method:'post',
        data: qs.stringify({
            plateformId:plateformId
        })
    })
}


export const queryThemeStyleInfo = (domain) => {
    return jwtServerInstance.request({
        url:'/b2customoneysetting/querytheme',
        method:'post',
        data: qs.stringify({
            domain: domain
        })
    })
}

export const queryCustomeSetting = () =>{
    return jwtServerInstance.request({
        url:'/b2creciveorderlimit/queryscsetting',
        method:'post'
    });
}


export const queryRentnumbers = (queryForm, pagination) =>{
    return jwtServerInstance.request({
        url:'/rentmanage/query',
        method:'post',
        data:qs.stringify({
            rentNumber:queryForm.rentNumber,
            rentStatus: queryForm.rentStatus,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    });
}

export const queryUserRentnumbers = (queryForm, pagination) =>{
    return jwtServerInstance.request({
        url:'/rentmanage/queryuser',
        method:'post',
        data:qs.stringify({
            rentStatus: queryForm.rentStatus,
            startTime: queryForm.startTime?queryForm.startTime:null,
            endTime: queryForm.endTime?queryForm.endTime:null,
            pageNum: pagination.pageNum,
            pageSize: pagination.pageSize
        })
    });
}

export const buyRentNumbers = (data) => {
    return jwtServerInstance.request({
        url:'/rentmanage/buyrentnumber',
        method:'post',
        data: qs.stringify({
            id: data.id
        })
    })
}


export const batchBuyRentNumbers = (data) => {
    return jwtServerInstance.request({
        url:'/rentmanage/batchbuyrentnumber',
        method:'post',
        data: data
    })
}

export const changeRentNumberStatus = (data) => {
    return jwtServerInstance.request({
        url:'/rentmanage/batchupdate',
        method:'post',
        data: data
    })
}


export const changeRentNumStatusFn = (data) => {
    return jwtServerInstance.request({
        url:'/rentmanage/update',
        method:'post',
        data: qs.stringify({
            id: data.id,
            rentStatus: data.rentStatus
        })
    })
}

export const queryRentnumbersWithStatus = () =>{
    return jwtServerInstance.request({
        url:'/rentmanage/querynumbers',
        method:'post'
    });
}

import service from '../../lib/kfRequest'

//网络请求监听
export const netWorkPing = (type = false) => {
    return service({
        url: '/service/ping',
        mobile: type === false,
        kefu: type,
        method: 'get',
        timeout: 1000,
    });
}

/*
  客户端 获取token接口
*/
export function adminAppCustomer() {
    console.log("adminAppCustomer called");
    return service({
        url: '/app',
        method: 'get', 
       region: 'admin', 
    })
}

export const userRecord = (params) => {
    return service({
        url: '/user/record',
        method: 'get',
        mobile: true,
        params
    });
}

export const serviceUpload = (data) => {
    return service({
        url: '/service/upload',
        method: 'post',
        mobile: true,
        data
    });
}

export const serviceAdv = (data) => {
    return service({
        url: '/service/adv',
        method: 'get',
        mobile: true
    });
}


export const userStatistics = (data) => {
    return service({
        url: 'user/statistics',
        method: 'post',
        mobile: true,
        data
    });
}

export const sendMessageMobile = (data) => {
    return service({
        url: '/service/send_message',
        method: 'post',
        mobile: true,
        data
    });
}

export const serviceInfo = () => {
    return service({
        url: '/service/info',
        method: 'get',
        kefu: true
    });
}